export const SET_WORKORDER = 'SET_WORKORDER'
export const INIT_WORKORDER = 'INIT_WORKORDER'
export const SET_TECHNICIANS = 'SET_TECHNICIANS'



// WEBPACK FOOTER //
// ./src/store/modules/maintenance/types.js